import React, { useState, useEffect } from 'react';
import { router, usePage } from '@inertiajs/react';
import { usePrevious } from 'react-use';
import SelectInput from '@/Components/Form/SelectInput';
import TextInput from '@/Components/Form/TextInput';
import { pickBy, omit } from 'lodash';
import ToggleInput from '@/Components/Form/ToggleInput';
import ActiveSearchFilters from '@/Components/ActiveSearchFilters';

export default () => {
	const { auth, filters, constants } = usePage().props;
	const [showAdvFilters, setShowAdvFilters] = useState(false);

	const [values, setValues] = useState({
		search: filters.search || '',
		region: filters.region || '',
		joined: filters.joined || ''
	});

	const prevValues = usePrevious(values);

	const toggleAdvFilters = () => setShowAdvFilters((value) => !value);

	useEffect(() => {
		if (prevValues) {
			const query = Object.keys(pickBy(values)).length ? pickBy(values) : '';

			const params = omit(route().params, Object.keys(filters));

			router.get(route(route().current(), params), query, {
				replace: true,
				preserveState: true,
				preserveScroll: true
			});
		}
	}, [values]);

	function handleChange(e) {
		const key = e.target.name;
		const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

		setValues((values) => ({
			...values,
			[key]: value
		}));
	}

	return (
		<>
			<div className="bg-base-300 p-4 rounded-box">
				<div className="flex gap-4 justify-between">
					<TextInput
						name="search"
						value={values.search}
						placeholder="Type here"
						onChange={handleChange}
						classes="grow"
					/>

					<button className="btn btn-square" onClick={toggleAdvFilters}>
						{showAdvFilters ? (
							<span className="material-icons-outlined">close</span>
						) : (
							<span className="material-icons-outlined">tune</span>
						)}
					</button>
				</div>
			</div>

			<ActiveSearchFilters values={values} setValues={setValues} />

			{showAdvFilters && (
				<div
					className="fixed inset-0 bg-black opacity-40 z-30"
					onClick={toggleAdvFilters}
				></div>
			)}

			<aside
				className={`bg-base-300 right-0 top-0 w-10/12 lg:w-96 fixed z-40 h-full p-6 transform transition-transform ease-in duration-150${
					showAdvFilters ? ' ' : ' translate-x-full'
				}`}
			>
				<div className="mb-4 text-right">
					<button className="btn btn-square" onClick={toggleAdvFilters}>
						<span className="material-icons-outlined">close</span>
					</button>
				</div>

				<SelectInput
					name="region"
					value={values.region}
					onChange={handleChange}
					classes="w-full mb-4"
				>
					<option value="">All regions</option>
					{constants.regions.map((region) => (
						<option key={region}>{region}</option>
					))}
				</SelectInput>

				<div className="divider"></div>

				{auth.user && (
					<ToggleInput
						label="Show Joined"
						name="joined"
						defaultChecked={values.joined}
						onChange={handleChange}
					/>
				)}
			</aside>
		</>
	);
};
